<template>
    <div class="animated fadeIn">

        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image get-app-splash" v-if="!isMobile()">
                                        <img alt="Download application splash" src="./assets/app-splash.svg">
                                    </figure>
                                    <figure class="image get-app-splash mobile-screen" v-else>
                                        <img alt="Download application splash" src="./assets/app-splash.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-1x">
                                <h1 class="title is-size-2 has-text-centered-mobile uptin-text-center">
                                    {{ $t('common:getapp.title') }}
                                </h1>
                            </div>
                            <div class="columns is-centered padding-top-2x">
                                <div class="columns content uptin-text-center has-padding-1x">
                                    <a class="button uptin-splash-button is-background-dark3" href="https://cafebazaar.ir/app/app.uptin.android">
                                        {{ $t('common:getapp.cafebazaar') }}
                                    </a>

                                </div>
                                <div class="columns content uptin-text-center has-padding-1x">
                                    <a class="button uptin-splash-button is-background-dark3"
                                       href="https://myket.ir/app/app.uptin.android"
                                        download="app.apk">
                                        {{ $t('common:getapp.myket') }}
                                    </a>
                                </div>
                                <div class="columns content uptin-text-center has-padding-1x">
                                    <a class="button uptin-splash-button is-background-dark3"
                                       href="https://sibapp.com/applications/Uptin"
                                       download="app.apk">
                                        {{ $t('common:getapp.sibapp') }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <pay-as-you-go></pay-as-you-go>
    </div>
</template>


<style lang="scss">

    .get-app-splash {
        max-width: 300px;
        min-width: 300px;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>


<script>
    import PayAsYouGo from "@/components/pay-as-you-go/pay-as-you-go"

    export default {
        name: 'uptin-download-app',
        components: {
            PayAsYouGo
        },
        data() {
            return {
            }
        },
        methods: {
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            }
        }
    }
</script>
